/**
 * Single source for the login pages' lazy chunks. `App.tsx` lazy-loads through
 * these, and the start page calls the same functions to warm the chunk before the
 * dawn transition: one import specifier each, so both resolve to the same chunk.
 */
export const loadLoginPage = () => import("./Login");
export const loadAdminLoginPage = () => import("./AdminLogin");
